module.exports = "https://coursera_assets.s3.amazonaws.com/images/4c1519ae23ed104e3b1d4d6fa51ac1ac.png";